import { Record } from '@common/data-models/records/record';
import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateLayouts } from "@common/enums/viewstate-layouts";
import { ViewStateOptions } from "@common/data-models/navigation/viewstate-options";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ViewStateFilterSerializer, ViewStateOptionsSerializer } from "@common/data-models/serializers/serializers";
import { GlobalTablesService } from "@common/services/global-tables-service";

export class WireViewStateRecord extends SingleViewStateRecord {
    
    public initialize() {
        this.viewStateType = ViewStateTypes.WIRE;
        super.initialize();
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions { return this.getAs<ViewStateOptions>("PSTViewStateLayout"); }
    public set viewStateLayout(value: ViewStateOptions) { this.set("PSTViewStateLayout", value); }

    public get viewStateMapZoomToCoverage(): boolean { return this.getAs<boolean>("PSTViewStateMapZoomToCoverage", true); }
    public set viewStateMapZoomToCoverage(value: boolean) { this.set("PSTViewStateMapZoomToCoverage", value); }

    public get viewStateMapShowTeamLocations(): boolean { return this.getAs<boolean>("PSTViewStateMapShowTeamLocations", false); }
    public set viewStateMapShowTeamLocations(value: boolean) { this.set("PSTViewStateMapShowTeamLocations", value); }

    public get viewStateMapLockMapLocation(): boolean { return this.getAs<boolean>("PSTViewStateMapLockMapLocation", false); }
    public set viewStateMapLockMapLocation(value: boolean) { this.set("PSTViewStateMapLockMapLocation", value); }

    public get viewStateMapCurrentZoom(): number { return this.getAs<number>("PSTViewStateMapCurrentZoom", 4); }
    public set viewStateMapCurrentZoom(value: number) { this.set("PSTViewStateMapCurrentZoom", value); }

    public get viewStateCurrentMapCenter(): string { return this.getAs<string>("PSTViewStateCurrentMapCenter"); }
    public set viewStateCurrentMapCenter(value: string) { this.set("PSTViewStateCurrentMapCenter", value); }
}
